// @flow
import React from 'react';
import Dotdotdot from 'react-dotdotdot';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { CallToAction } from 'components/atoms/callToAction';
import type { Artist, Event } from 'types/event';
import { HTMLView } from 'components/atoms/htmlView';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: Event,
  onClick: () => void,
  className?: string,
};

export const EventArtistCard = (props: Props) => {
  const { data, className, onClick } = props;
  if (!data) {
    return null;
  }

  const { artists } = data;
  const containerClass = classNames('event-artist-card', className);

  return (
    <div className={containerClass}>
      <div className={'event-details'}>
        <Dotdotdot clamp={2} tagName={'h2'}>
          {data.name}
        </Dotdotdot>
        {renderArtists(artists)}
        <span>{data.genre}</span>
        <HTMLView tagName={'p'} className={'header'} html={data.description} />
      </div>
      <CallToAction
        text={'Learn more'}
        onClick={onClick}
        type={'link'}
        mode={'transparent'}
        size={'small'}
        className={'events-cta-button'}
      />
    </div>
  );
};
//
// const renderArtists = (artists: Array<Artist>) => {
//   console.log(artists);
//   if (artists.length < 2) {
//     return null;
//   }
//
//   return (
//     <div className={'artist-links'}>
//       {artists.map((artist, idx) => {
//         if (idx === artists.length - 1) {
//           return (
//             <>
//               <span>and&nbsp;</span>
//               <Link to={`/artists/${artist.urlSlug}`}>{artist.name}</Link>
//             </>
//           );
//         }
//         return (
//           <>
//             <Link to={`/artists/${artist.urlSlug}`}>{artist.name}</Link>
//             <span>&#44;&nbsp;</span>
//           </>
//         );
//       })}
//     </div>
//   );
// };

const renderArtists = (artists: Array<Artist>) => {
  if (artists.length < 1) {
    return null;
  }

  return (
    <div className={'artist-links'}>
      {artists.map((artist, idx) => {
        if (idx === artists.length - 1 && artists.length > 1) {
          return (
            <>
              <span>and&nbsp;</span>
              <span className={'artist-name'}>{artist.name}</span>
            </>
          );
        }
        return (
          <>
            <span className={'artist-name'}>{artist.name}</span>
            {idx !== artists.length - 2 && artists.length > 2 ? (
              <span>&#44;&nbsp;</span>
            ) : (
              <span>&nbsp;</span>
            )}
          </>
        );
      })}
    </div>
  );
};
